(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var searchaniseRoot = document.querySelector('[data-collection-searchanise]');
    var fallbackMount = document.querySelector('[data-collection-fallback-mount]');
    if (!searchaniseRoot || !fallbackMount) return;

    var settled = false;
    var TIMEOUT_MS = 5000;
    var timer = null;
    var observer = null;

    function searchaniseReady() {
      if (searchaniseRoot.querySelector('.snize-product')) return true;
      if (
        !searchaniseRoot.querySelector('#snize_skeleton_results') &&
        searchaniseRoot.querySelector(
          '#snize_results .snize-search-results-content, #snize_results .snize-filters-panel, #snize_results [class*="snize-product"]'
        )
      ) {
        return true;
      }
      return false;
    }

    function markReady() {
      if (settled) return;
      settled = true;
      if (timer) clearTimeout(timer);
      if (observer) observer.disconnect();
    }

    function showFallback() {
      if (settled) return;
      settled = true;
      if (observer) observer.disconnect();

      var separator = window.location.search ? '&' : '?';
      var url =
        window.location.pathname +
        window.location.search +
        separator +
        'sections=collection-native-fallback';

      fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('fallback fetch failed');
          return response.json();
        })
        .then(function (data) {
          var html = data['collection-native-fallback'];
          if (!html) return;
          searchaniseRoot.hidden = true;
          fallbackMount.hidden = false;
          fallbackMount.innerHTML = html;
        })
        .catch(function () {});
    }

    if (searchaniseReady()) {
      markReady();
      return;
    }

    observer = new MutationObserver(function () {
      if (searchaniseReady()) markReady();
    });
    observer.observe(searchaniseRoot, { childList: true, subtree: true });

    timer = setTimeout(function () {
      if (searchaniseReady()) {
        markReady();
        return;
      }
      showFallback();
    }, TIMEOUT_MS);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    var refreshTimer = null;
    var wrapped = false;

    function getBar() {
      return document.querySelector('[data-free-shipping-bar]');
    }

    function formatMoney(cents, format) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, format);
      }

      var value = (Number(cents) / 100).toFixed(2);
      var placeholderOpen = '{' + '{';
      var placeholderClose = '}' + '}';
      var formatString = format || ('$' + placeholderOpen + 'amount' + placeholderClose);
      var parts = value.split('.');
      var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var amount = dollars + '.' + parts[1];
      var amountNoDecimals = dollars;
      var amountWithCommaSeparator = dollars.replace(/,/g, '.') + ',' + parts[1];

      return formatString
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithCommaSeparator)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }

    function cartHasRecordPlanet(cart, handle) {
      if (!cart || !cart.items || !handle) return false;
      return cart.items.some(function (item) {
        return item.handle === handle;
      });
    }

    function updateBar(cart) {
      var bar = getBar();
      if (!bar) return;

      if (cartHasRecordPlanet(cart, bar.dataset.recordPlanetHandle)) {
        bar.hidden = true;
        return;
      }

      var threshold = Number(bar.dataset.threshold) || 0;
      var total = Number(cart.total_price) || 0;
      var msgEl = bar.querySelector('.free-shipping-bar__msg');
      var progress = 0;
      var message = bar.dataset.msgEmpty || '';

      if (total >= threshold && threshold > 0) {
        progress = 100;
        message = bar.dataset.msgUnlocked || '';
      } else if (total > 0 && threshold > 0) {
        progress = Math.min(100, Math.floor((total * 100) / threshold));
        var remaining = Math.max(threshold - total, 0);
        var remainingMoney = formatMoney(remaining, bar.dataset.moneyFormat);
        message = (bar.dataset.msgRemaining || '').replace(/__AMOUNT__/g, remainingMoney);
      }

      if (msgEl) msgEl.innerHTML = message;
      bar.style.setProperty('--free-shipping-progress', progress + '%');
      bar.classList.toggle('free-shipping-bar--unlocked', progress >= 100);
      bar.hidden = false;
    }

    function refreshBar() {
      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart.js'
        : '/cart.js')
        .then(function (response) {
          if (!response.ok) throw new Error('Cart request failed');
          return response.json();
        })
        .then(updateBar)
        .catch(function () {});
    }

    function scheduleRefresh() {
      if (refreshTimer) clearTimeout(refreshTimer);
      refreshTimer = setTimeout(refreshBar, 150);
    }

    function isCartMutation(url) {
      return typeof url === 'string' && CART_MUTATION.test(url);
    }

    function requestUrl(input) {
      if (typeof input === 'string') return input;
      if (input && typeof input.url === 'string') return input.url;
      return '';
    }

    function wrapNetwork() {
      if (wrapped) return;
      wrapped = true;

      if (typeof window.fetch === 'function') {
        var originalFetch = window.fetch;
        window.fetch = function () {
          var url = requestUrl(arguments[0]);
          return originalFetch.apply(this, arguments).then(function (response) {
            if (isCartMutation(url) && response.ok) scheduleRefresh();
            return response;
          });
        };
      }

      if (typeof XMLHttpRequest !== 'undefined') {
        var originalOpen = XMLHttpRequest.prototype.open;
        var originalSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function (method, url) {
          this._freeShippingBarUrl = url;
          return originalOpen.apply(this, arguments);
        };

        XMLHttpRequest.prototype.send = function () {
          if (isCartMutation(String(this._freeShippingBarUrl || ''))) {
            this.addEventListener('load', function () {
              if (this.status >= 200 && this.status < 300) scheduleRefresh();
            });
          }
          return originalSend.apply(this, arguments);
        };
      }
    }

    wrapNetwork();
    document.addEventListener('cart:updated', scheduleRefresh);
    document.addEventListener('cart:refresh', scheduleRefresh);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var hamburgerBtn = document.getElementById('SiteHeaderHamburger');
    var mobileMenu   = document.getElementById('SiteMobileMenu');
    var header       = hamburgerBtn && hamburgerBtn.closest('.site-header');

    if (hamburgerBtn && mobileMenu) {
      var openMenu = function () {
        hamburgerBtn.setAttribute('aria-expanded', 'true');
        hamburgerBtn.setAttribute('aria-label', 'Close navigation menu');
        mobileMenu.setAttribute('aria-hidden', 'false');
        mobileMenu.classList.add('site-header__mobile-menu--open');
        if (header) header.classList.add('site-header--menu-open');
      };

      var closeMenu = function () {
        hamburgerBtn.setAttribute('aria-expanded', 'false');
        hamburgerBtn.setAttribute('aria-label', 'Open navigation menu');
        mobileMenu.setAttribute('aria-hidden', 'true');
        mobileMenu.classList.remove('site-header__mobile-menu--open');
        if (header) header.classList.remove('site-header--menu-open');
      };

      hamburgerBtn.addEventListener('click', function () {
        hamburgerBtn.getAttribute('aria-expanded') === 'true' ? closeMenu() : openMenu();
      });

      // Close on Escape key
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && hamburgerBtn.getAttribute('aria-expanded') === 'true') closeMenu();
      });

      // Close when a mobile link is tapped
      mobileMenu.querySelectorAll('.mobile-menu__link').forEach(function (link) {
        link.addEventListener('click', closeMenu);
      });
    }

    var searchWrap    = document.querySelector('.site-header__search-wrap');
    var searchTrigger  = document.getElementById('SiteHeaderSearchTrigger');
    var searchPanel    = document.getElementById('SiteHeaderSearchPanel');

    if (searchWrap && searchTrigger && searchPanel) {
      var isSearchaniseEventTarget = function (target) {
        if (!target || !target.closest) return false;
        return Boolean(
          target.closest(
            '#snize-instant-search-results, .snize-ac-results, .snize-mobile-top-panel, #snize-mobile-search-input'
          )
        );
      };

      var onDocumentClick = function (event) {
        if (searchWrap.contains(event.target)) return;
        if (isSearchaniseEventTarget(event.target)) return;
        if (document.body.classList.contains('snize-instant-widget-is-open')) return;
        closeSearch();
      };

      var onSearchKeydown = function (event) {
        if (event.key === 'Escape') closeSearch();
      };

      var activateSearchaniseMobile = function (input) {
        if (!input) return;
        if (!window.matchMedia('(max-width: 56em)').matches) return;
        input.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
        input.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true }));
        input.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      };

      var openSearch = function () {
        searchPanel.hidden = false;
        searchPanel.setAttribute('aria-hidden', 'false');
        searchTrigger.setAttribute('aria-expanded', 'true');
        var input = searchPanel.querySelector('input[type="search"], input[name="q"]');
        if (input) {
          input.focus();
          window.requestAnimationFrame(function () {
            activateSearchaniseMobile(input);
          });
        }
        document.addEventListener('keydown', onSearchKeydown);
        window.setTimeout(function () {
          document.addEventListener('click', onDocumentClick);
        }, 0);
      };

      var closeSearch = function () {
        searchPanel.hidden = true;
        searchPanel.setAttribute('aria-hidden', 'true');
        searchTrigger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', onDocumentClick);
        document.removeEventListener('keydown', onSearchKeydown);
        if (window.Searchanise) {
          try {
            if (typeof window.Searchanise.AutocompleteCloseAll === 'function') {
              window.Searchanise.AutocompleteCloseAll();
            } else if (typeof window.Searchanise.AutocompleteClose === 'function') {
              window.Searchanise.AutocompleteClose();
            }
          } catch (error) {}
        }
      };

      searchTrigger.addEventListener('click', function (event) {
        event.stopPropagation();
        searchTrigger.getAttribute('aria-expanded') === 'true' ? closeSearch() : openSearch();
      });
    }

    var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    var cartRefreshTimer = null;
    var cartNetworkWrapped = false;

    function cartLabel(count) {
      if (count < 1) return 'Cart';
      if (count === 1) return 'Cart (1 item)';
      return 'Cart (' + count + ' items)';
    }

    function updateCartBadge(cart) {
      var link = document.querySelector('[data-cart-link]');
      var badge = document.querySelector('[data-cart-count]');
      if (!link || !badge) return;

      var count = Number(cart.item_count) || 0;
      badge.textContent = String(count);
      badge.hidden = count < 1;
      link.setAttribute('aria-label', cartLabel(count));
    }

    function refreshCartBadge() {
      var cartUrl =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart.js'
          : '/cart.js';

      fetch(cartUrl)
        .then(function (response) {
          if (!response.ok) throw new Error('Cart request failed');
          return response.json();
        })
        .then(updateCartBadge)
        .catch(function () {});
    }

    function scheduleCartBadgeRefresh() {
      if (cartRefreshTimer) clearTimeout(cartRefreshTimer);
      cartRefreshTimer = setTimeout(refreshCartBadge, 150);
    }

    function isCartMutation(url) {
      return typeof url === 'string' && CART_MUTATION.test(url);
    }

    function requestUrl(input) {
      if (typeof input === 'string') return input;
      if (input && typeof input.url === 'string') return input.url;
      return '';
    }

    function wrapCartNetwork() {
      if (cartNetworkWrapped) return;
      cartNetworkWrapped = true;

      if (typeof window.fetch === 'function') {
        var originalFetch = window.fetch;
        window.fetch = function () {
          var url = requestUrl(arguments[0]);
          return originalFetch.apply(this, arguments).then(function (response) {
            if (isCartMutation(url) && response.ok) scheduleCartBadgeRefresh();
            return response;
          });
        };
      }

      if (typeof XMLHttpRequest !== 'undefined') {
        var originalOpen = XMLHttpRequest.prototype.open;
        var originalSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function (method, url) {
          this._cartBadgeUrl = url;
          return originalOpen.apply(this, arguments);
        };

        XMLHttpRequest.prototype.send = function () {
          if (isCartMutation(String(this._cartBadgeUrl || ''))) {
            this.addEventListener('load', function () {
              if (this.status >= 200 && this.status < 300) scheduleCartBadgeRefresh();
            });
          }
          return originalSend.apply(this, arguments);
        };
      }
    }

    wrapCartNetwork();
    document.addEventListener('cart:updated', scheduleCartBadgeRefresh);
    document.addEventListener('cart:refresh', scheduleCartBadgeRefresh);
  })();

  } catch(e) { console.error(e); }
})();
})();
